import { Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Content from '../components/Layout/Content';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import ReusableTable from '../components/ReusableTable/ReusableTable';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import SearchBar from '../components/SearchBar/Search';
import { ServiceFlyout } from '../components/ServiceFlyout/ServiceFlyout';
import {
  handleTimeFilter,
  searchDataByKey,
  consentArrayConvertor,
} from '../shared/helper';
import {
  dateFilterMenuItems,
  consentFilterMenuItems,
} from '../shared/constants';

import NotFound from '../components/NotFound/NotFoundPage';
import { useQuery } from '@apollo/client';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import { FETCH_ALL_CONSENTS_QUERY } from '../services/ConsentQueries/ConsentService';
import {
  CONSENT,
  CONSENT_TABLE_HEADING as tableHeading,
  CONSENT_BREADCRUMBDATA as breadcrumbData,
} from '../shared/Strings';

const table = {
  marginTop: 8,
  '& .css-1kn3lhz': {},
};

const flyoutTitles = [
  'Received from:',
  'Received on:',
  'Email ID:',
  'Phone number:',
  'Role:',
  'Type of consent:',
  'Status:',
];

const flyoutDetails = [
  'Robert Bedford',
  'May 24, 2021',
  'js1234@gmail.com',
  '(555) 555-1234',
  'Healthcare Advocate',
  'Consent to share',
  'Declined',
];

export const Consent = () => {
  const [timeFilter, setTimeFilter] = useState('all');
  const [searchValue, setSearchValue] = useState('');
  const [recordsData, setRecordedData] = useState([]);
  const [consentFilter, setConsentFilter] = useState('all');
  const [openFlyout, setOpenFlyout] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const allConsents = useQuery(FETCH_ALL_CONSENTS_QUERY, {
    variables: {
      sourceUrl: '',
      consentType: 'ALL',
      offset: 0,
      count: '10',
      dateFilter: 0,
      statusFilter: '',
      searchFilter: '',
    },
  });

  useEffect(() => {
    if (allConsents.data) {
      let result = allConsents.data.fetchReceivedConsents.consentList;
      let parsed = JSON.parse(result);
      let data = consentArrayConvertor(parsed);
      setRecordedData(data);
      setFilteredData(data);
    }
  }, [allConsents.data]);

  const viewDetailsHandler = () => {
    setOpenFlyout(true);
  };

  const closeFlyout = () => {
    setOpenFlyout(false);
  };

  const onSearch = text => {
    setSearchValue(text);
  };

  const dateFilterOptions = {
    options: dateFilterMenuItems,
    value: timeFilter,
    changeHandler: ev => {
      setTimeFilter(ev.target.value);
    },
  };

  const consentFilterOptions = {
    options: consentFilterMenuItems,
    value: consentFilter,
    changeHandler: ev => {
      setConsentFilter(ev.target.value);
    },
  };

  const handleConsentTypeFilter = (filterVal, key, totalData) => {
    const searchedText = filterVal.toLocaleLowerCase();

    if (searchedText === 'all') {
      return totalData;
    }
    // eslint-disable-next-line array-callback-return
    return totalData.filter(obj => {
      if (obj[key]) {
        return obj[key].toLowerCase().includes(searchedText);
      }
    });
  };

  useEffect(() => {
    const timeFilteredData = handleTimeFilter(
      timeFilter,
      recordsData,
      'receivedOn'
    );
    const consentTypeFilteredData = handleConsentTypeFilter(
      consentFilter,
      'typeOfConsent',
      timeFilteredData
    );
    const searchData = searchDataByKey(
      consentTypeFilteredData,
      'receivedFrom',
      searchValue
    );
    setFilteredData(searchData);
  }, [timeFilter, recordsData, searchValue, consentFilter]);

  const ConsentFlyout = () => {
    return (
      <Paper variant="outlined" sx={{ borderRadius: '8px', padding: '24px' }}>
        <Grid container spacing={12}>
          <Grid item sx={{ flexDirection: 'column' }}>
            <Typography>
              {flyoutTitles.map((item, index) => (
                <Box
                  sx={{ fontSize: '16px', fontWeight: 400, mb: '10px' }}
                  key={index}>
                  {item}
                </Box>
              ))}
            </Typography>
          </Grid>
          <Grid item sx={{ flexDirection: 'column' }}>
            <Typography>
              {flyoutDetails.map((item, index) => (
                <Box
                  key={index}
                  sx={{ fontSize: '16px', fontWeight: 500, mb: '10px' }}>
                  {item}
                </Box>
              ))}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    );
  };

  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: { xs: '95%', sm: '100%' },
        }}>
        <Typography variant="title">{CONSENT.TITLE_TEXT}</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          position: 'relative',
          top: 40,
          flexWrap: 'wrap',
        }}>
        <SearchBar
          sx={{
            width: '50%',
            minWidth: '250px',
            maxWidth: '500px',
            marginTop: '8px',
          }}
          onSearch={onSearch}
          placeholder={CONSENT.SEARCH_PLACEHOLDER_TEXT}
        />
        <FilterDropDown {...dateFilterOptions} filterType="Date:" />
        <FilterDropDown {...consentFilterOptions} filterType="Consents:" />
      </Box>
      <Box sx={table}>
        {!allConsents.loading && !filteredData.length ? (
          <NotFound title={CONSENT.TITLE_TEXT} />
        ) : (
          <ReusableTable
            tableHeading={tableHeading}
            data={filteredData}
            viewDetailsHandler={viewDetailsHandler}
          />
        )}
      </Box>
      <ServiceFlyout
        isOpen={openFlyout}
        handleClose={closeFlyout}
        title={CONSENT.CONSENT_DETAILS}>
        <ConsentFlyout />
      </ServiceFlyout>
      <SimpleBackdrop open={allConsents.loading} />
    </Content>
  );
};
